import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import axios from "axios";
const DeleteAndEditEvent = ({
  selectedDate,
  events,
  onEdit,
  setSelectedDate,
  setEvents,
  tasks,
  email,
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedDate(null);
  };
  let keys = [
    "Event",
    "Description",
    "Start",
    "End", //"Edit",
    "Delete",
  ];
  const onDelete = (id) => {
    axios
      .delete("https://calenderbackend-seven.vercel.app/calendar/events", {
        params: { email, id },
      })
      .then((response) => {
        let alltasks = tasks.filter((task) => task.id !== id);
        setEvents(alltasks || []); // Update the event list
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <Dialog
      open={true}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          width: "80vw", // Set dialog width to 60% of viewport width
          maxWidth: "none", // Disable Material-UI's default max width
        },
      }}
    >
      <DialogTitle>Event on {selectedDate} </DialogTitle>
      <DialogContent sx={{ padding: 1 }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {keys.map((key, index) => (
                  <TableCell key={index}>{key}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {events.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{row.summary}</TableCell>
                  <TableCell>{row.description}</TableCell>
                  <TableCell>{row.start.dateTime}</TableCell>
                  <TableCell>{row.end.dateTime}</TableCell>
                  {/* <TableCell ><EditIcon onClick={handleClickOpen} /></TableCell> */}
                  <TableCell>
                    <DeleteIcon onClick={() => onDelete(row.id)} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAndEditEvent;
